import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';

export const GET_SERIES_REQUEST = 'GET_SERIES_REQUEST';
export const GET_SERIES_SUCCESS = 'GET_SERIES_SUCCESS';
export const GET_SERIES_ERROR = 'GET_SERIES_ERROR';

export const CREATE_SERIE_REQUEST = 'CREATE_SERIE_REQUEST';
export const CREATE_SERIE_SUCCESS = 'CREATE_SERIE_SUCCESS';
export const CREATE_SERIE_ERROR = 'CREATE_SERIE_ERROR';

export const UPDATE_SERIE_REQUEST = 'UPDATE_SERIE_REQUEST';
export const UPDATE_SERIE_SUCCESS = 'UPDATE_SERIE_SUCCESS';
export const UPDATE_SERIE_ERROR = 'UPDATE_SERIE_ERROR';

export const DELETE_SERIE_REQUEST = 'DELETE_SERIE_REQUEST';
export const DELETE_SERIE_SUCCESS = 'DELETE_SERIE_SUCCESS';
export const DELETE_SERIE_ERROR = 'DELETE_SERIE_ERROR';

export const CLEAN_SERIES = 'CLEAN_SERIES';

// Get series
export function getSeries(query) {
    return async (dispatch) => {
        try {
            dispatch(getSeriesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/series/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getSeriesSuccess, getSeriesError));
        } catch (err) {
            dispatch(utilsLib.response(err, getSeriesError));
        }
    };
}
function getSeriesRequest() {
    return {
        type: GET_SERIES_REQUEST,
        isFetching: true
    };
}
function getSeriesSuccess (payload) {
    return {
        type: GET_SERIES_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getSeriesError(errorMessage) {
    return {
        type: GET_SERIES_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create serie
export function createSerie(serie) {
    return async (dispatch) => {
        try {
            dispatch(createSerieRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/series', serie, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createSerieSuccess, createSerieError));
        } catch (err) {
            dispatch(utilsLib.response(err, createSerieError));
        }
    };
}
function createSerieRequest() {
    return {
        type: CREATE_SERIE_REQUEST,
        isFetching: true
    };
}
function createSerieSuccess (payload) {
    return dispatch => {
        // Create notification for create serie success
        dispatch(addNotification({
            message: 'Numeración de documentos añadida correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_SERIE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function createSerieError(errorMessage) {
    return dispatch => {
        // Create notification for create serie error
        dispatch(addNotification({
            message: 'Error al añadir la numeración de documentos',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_SERIE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update serie
export function updateSerie(serieId, serie = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateSerieRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/series/${serieId}`, serie, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateSerieSuccess, updateSerieError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateSerieError));
        }
    };
}
function updateSerieRequest() {
    return {
        type: UPDATE_SERIE_REQUEST,
        isFetching: true
    };
}
function updateSerieSuccess (payload) {
    return dispatch => {
        // Create notification for update serie success
        dispatch(addNotification({
            message: 'Numeración de documentos actualizada correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_SERIE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function updateSerieError(errorMessage) {
    return dispatch => {
        // Create notification for update serie error
        dispatch(addNotification({
            message: 'Error al actualizar la numeración de documentos',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_SERIE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete serie
export function deleteSerie(serieId) {

    return async (dispatch) => {
        try {
            dispatch(deleteSerieRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/series/${serieId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteSerieSuccess, deleteSerieError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteSerieError));
        }
    };
}
function deleteSerieRequest() {
    return {
        type: DELETE_SERIE_REQUEST,
        isFetching: true
    };
}
function deleteSerieSuccess (payload) {
    return dispatch => {
        // Create notification for delete serie success
        dispatch(addNotification({
            message: 'Numeración de documentos eliminada correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_SERIE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteSerieError(errorMessage) {
    return dispatch => {
        // Create notification for delete serie error
        dispatch(addNotification({
            message: 'Error al eliminar numeración de documentos',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_SERIE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean series reducer
export function cleanSeries() {
    return {
        type: 'CLEAN_SERIES',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/series.js